"use client";

import React from 'react';
import clsx from 'clsx';
import type { ThemeColorsBorder, ThemeSpaces } from '@frameio/vapor-theme';
import { theme } from '@frameio/vapor-theme';
import styles from './Separator.module.css';

export type SeparatorProps = {
  color?: ThemeColorsBorder;
  gap?: ThemeSpaces;
  height?: ThemeSpaces | '100%';
  vertical?: boolean;
  stretch?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export const Separator = ({
  color = 'primary',
  gap = 0,
  height,
  vertical = false,
  stretch,
  className,
  style,
  ...other
}: SeparatorProps) => {
  let separatorHeight: string | undefined;
  if (height === '100%') {
    separatorHeight = '100%';
  } else if (height != null) {
    separatorHeight = theme.spaces[height as ThemeSpaces];
  }

  const cssVars = {
    // @ts-expect-error FIXME(noImplicitAny)
    '--vapor-separator-color': theme.colors.border[color],
    '--vapor-separator-gap': theme.spaces[gap as ThemeSpaces],
    '--vapor-separator-height': separatorHeight,
    ...style,
  } as React.CSSProperties;

  return (
    <div
      className={clsx(styles.separator, className)}
      data-stretch={stretch || undefined}
      data-vertical={vertical || undefined}
      role="separator"
      style={cssVars}
      {...other}
    />
  );
};
